import { defineComponent as _defineComponent } from 'vue'
import {
  Heading,
  HeadingDisplay,
  BaseText,
  CopyButton
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { ICustomerBankAccountResponse } from '@/modules/transaction/services/new-deposit';
import { computed } from 'vue';

interface Props {
  depositInformation: ICustomerBankAccountResponse['bankAccount'];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TedSection',
  props: {
    depositInformation: null
  },
  setup(__props: any) {

const props = __props as {
  depositInformation: ICustomerBankAccountResponse['bankAccount'];
}



const computedBankInfo = computed(() => {
  return [
    {
      label: 'Banco',
      value: props.depositInformation?.bankCode
    },
    {
      label: 'Agência',
      value: props.depositInformation?.agency
    },
    {
      label: 'Conta',
      value: props.depositInformation?.account
    }
  ];
});

const bankName = computed(() => {
  return props.depositInformation?.bankName;
});

function getAccountValueStyle(label: string) {
  return label === 'Conta' ? 'deposit-method__account-value' : '';
}

return { __sfc: true,props, computedBankInfo, bankName, getAccountValueStyle, Heading, HeadingDisplay, BaseText, CopyButton, NebraskaColors }
}

})